<template>
  <div class="@container flex flex-col">
    <div
      v-if="requestData"
      :id="`request_control_panel_${requestData.id}`">
      <div class="grid p-2 shadow-sm rounded-md gap-1"
        :class="{
          'bg-gray-50': index % 2 === 0,
          'bg-white': index % 2 !== 0,
          'grid-cols-3': showRequestData,
          'grid-cols-2': !showRequestData,
        }">
        <div class="grid grid-cols-2"
          v-if="showRequestData">
          <span class="text-sm">
            {{ requestData.internalId }}
          </span>
          <span class="text-sm">
            {{ requestData.studentName }}
          </span>
          <span class="text-sm">
            {{ requestData.type }}
          </span>
          <span class="text-sm">
            {{ requestData.createdAt }}
          </span>
        </div>
        <div class="col-span-2 flex flex-col @xl:grid @xl:grid-cols-4 gap-1">
          <div v-for="componentData in componentDataTemplate"
            :key="componentData.type">
            <div class="flex flex-col gap-1">
              <div class="flex flex-row items-center gap-2">
                <span class="text-sm">{{ componentData.display }}:</span>
                <div class="border-solid border-4 rounded-xl w-8 min-h-8 text-lg font-extrabold leading-7 text-center uppercase"
                  :class="{
                    'border-slate-300 text-slate-300': ['C', 'N'].includes(requestData[componentData.checkData]),
                    'border-red-500 text-red-500': 'E' === requestData[componentData.checkData],
                    'border-black text-black': ['P', 'R'].includes(requestData[componentData.checkData]),
                  }">
                  {{ displayStatus(requestData[componentData.checkData]) }}
                </div>
              </div>
              <Button class="p-2 rounded-md"
                :class="{
                  'opacity-50': ['C', 'N'].includes(requestData[componentData.checkData]),
                  'opacity-100': ['P', 'R', 'E'].includes(requestData[componentData.checkData]),
                }"
                color="gray"
                @click="rerunTaskButton(componentData.type)"
                :disabled="false">
                {{ componentData.rerunDisplay }}
                <Spinner
                  class="h-4 w-4"
                  v-show="submissionTracking[componentData.checkData]"
                />
              </Button>
              <div class="flex flex-row items-center gap-2 mb-2"
                v-show="confirmRerunTask[componentData.checkData]">
                <XButton class="rounded-md w-6 h-6 p-1 bg-red-500"
                  @click="cancelRerunConfirm(componentData.checkData)">
                </XButton>
                <span>
                  Confirm:
                </span>
                <Button class="p-2 rounded-md"
                  color="gray"
                  @click="acceptRerunConfirm(componentData.checkData)">
                  Re-run
                </Button>
              </div>
              <div class="flex flex-col"
                v-if="requestData.errorLogs[componentData.errorLogKey] != undefined">
                <Button class="p-2 rounded-md"
                  color="gray"
                  @click="viewError(componentData.errorLogKey)">
                  View Error
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col mx-2 border-solid border-2 rounded-md border-gray-400"
        v-show="showDetail">
        <Button
          @click="() => { showDetail = false }">
          Close Detail
        </Button>
        <div
          v-for="errorLogData in errorLogDatas"
          :key="errorLogData.id">
          <div class="flex flex-row items-start, min-h-20, p-4 gap-2 border-solid border-gray-400 border-t">
            <span class="mt-2">
              {{ errorLogData.display }}
            </span>
            <span class="mt-2 font-mono whitespace-pre text-xs leading-3">
              {{ errorLogData.content }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <Spinner
      v-else
      message="Loading Request Data"
    />
  </div>
</template>

<script>
import Button from '../../Button.vue'
import XButton from '../../XButton.vue'
import Spinner from '../../Spinner.vue'

export default {
  components: {
    Button,
    XButton,
    Spinner,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    requestData: Object,
    showRequestData: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      componentDataTemplate: [
        {
          type: 'email_generated',
          display: 'Email',
          checkData: 'sendEmail',
          rerunDisplay: 'Regenerate Email',
          errorLogKey: 'sendEmail',
        },
        {
          type: 'noreply_email_generated',
          display: 'Noreply Email',
          checkData: 'sendNoreplyEmail',
          rerunDisplay: 'Regenerate Noreply',
          errorLogKey: 'sendNoreplyEmail',
        },
        {
          type: 'student_sync',
          display: 'Student Sync',
          checkData: 'syncBuilding',
          rerunDisplay: 'Resync Request',
          errorLogKey: 'syncBuilding',
        },
        {
          type: 'building_sync',
          display: 'Building Sync',
          checkData: 'syncStudent',
          rerunDisplay: 'Resync Building',
          errorLogKey: 'syncStudent',
        },
      ],
      submissionTracking: {},
      confirmRerunTask: {},
      showDetail: false,
      errorLogDatas: [],
    }
  },
  methods: {
    displayStatus(requestValue) {
      return requestValue
    },
    rerunTaskButton(taskType) {
      this.confirmRerunTask[taskType] = true
    },
    cancelRerunConfirm(taskType) {
      this.confirmRerunTask[taskType] = false
    },
    acceptRerunConfirm(taskType) {
      this.submissionTracking[taskType] = true
      this.$emit('runTask', taskType, this.requestData.id)
    },
    viewError() {
      this.showDetail = true
    },
  },
}
</script>
